import React, { HTMLAttributes } from 'react';

const Tenants = ({ className }: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    width="25"
    height="25"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M32.685 21.496a5.097 5.097 0 0 0 1.962-4.018 5.11 5.11 0 0 0-5.105-5.104 5.11 5.11 0 0 0-5.104 5.104c0 1.63.768 3.081 1.96 4.016a10.397 10.397 0 0 0-3.46 1.869 12.941 12.941 0 0 0-6.539-4.31 6.194 6.194 0 0 0 2.7-5.112 6.203 6.203 0 0 0-6.196-6.196 6.203 6.203 0 0 0-6.197 6.196c0 2.119 1.07 3.992 2.697 5.11C3.983 20.581 0 25.57 0 31.471c0 .433.351.785.784.785h38.432A.784.784 0 0 0 40 31.47c0-4.672-3.08-8.637-7.315-9.975Zm-6.678-4.018a3.54 3.54 0 0 1 3.535-3.535 3.54 3.54 0 0 1 3.536 3.535 3.54 3.54 0 0 1-3.536 3.536 3.54 3.54 0 0 1-3.535-3.536ZM8.275 13.941a4.633 4.633 0 0 1 4.628-4.628 4.633 4.633 0 0 1 4.628 4.628 4.633 4.633 0 0 1-4.628 4.628 4.633 4.633 0 0 1-4.628-4.628Zm-6.68 16.746c.405-5.885 5.322-10.55 11.308-10.55 3.679 0 7.14 1.797 9.266 4.806l.004.005.01.014a11.249 11.249 0 0 1 2.027 5.725H1.596Zm24.187 0a12.803 12.803 0 0 0-1.93-6.045 8.841 8.841 0 0 1 5.69-2.06c4.637 0 8.456 3.57 8.854 8.105H25.782Z"
      fill="#000"
    />
    <path
      d="M18.632 27.765h-5.726a.784.784 0 0 0 0 1.569h5.726a.784.784 0 0 0 0-1.569ZM21.604 27.765c-1.01 0-1.011 1.569 0 1.569 1.01 0 1.011-1.569 0-1.569Z"
      fill="#000"
    />
  </svg>
);

export default Tenants;
